import * as d3 from 'd3';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const W = 180;
const H = 110;
const CX = W / 2;
const CY = H - 10;
const R_OUTER = 80;
const R_INNER = 52;
const START_ANGLE = -Math.PI * 0.75;
const END_ANGLE = Math.PI * 0.75;

export default function ChannelGauge({
  value = undefined, min, max, unit, label,
}) {
  const svgRef = useRef(null);

  const safeValue = typeof value === 'number' ? value : min;
  const fraction = Math.max(0, Math.min(1, (safeValue - min) / (max - min)));
  const needleAngle = START_ANGLE + fraction * (END_ANGLE - START_ANGLE);

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    svg.selectAll('*').remove();

    const arcBg = d3.arc()
      .innerRadius(R_INNER)
      .outerRadius(R_OUTER)
      .startAngle(START_ANGLE)
      .endAngle(END_ANGLE);

    const arcFill = d3.arc()
      .innerRadius(R_INNER)
      .outerRadius(R_OUTER)
      .startAngle(START_ANGLE)
      .endAngle(START_ANGLE + fraction * (END_ANGLE - START_ANGLE));

    const g = svg.append('g').attr('transform', `translate(${CX},${CY})`);

    g.append('path')
      .attr('d', arcBg())
      .attr('fill', '#e9ebed');

    g.append('path')
      .attr('d', arcFill())
      .attr('fill', value === undefined ? '#e9ebed' : '#0972d3');

    const nx = Math.cos(needleAngle - Math.PI / 2) * (R_INNER - 6);
    const ny = Math.sin(needleAngle - Math.PI / 2) * (R_INNER - 6);
    g.append('line')
      .attr('x1', 0).attr('y1', 0)
      .attr('x2', nx)
      .attr('y2', ny)
      .attr('stroke', '#16191f')
      .attr('stroke-width', 2)
      .attr('stroke-linecap', 'round');

    g.append('circle').attr('r', 4).attr('fill', '#16191f');
  }, [fraction, needleAngle, value]);

  return (
    <div style={{ textAlign: 'center', width: W }}>
      <svg ref={svgRef} width={W} height={H} />
      <div style={{ fontSize: 18, fontWeight: 600, marginTop: -8 }}>
        {value !== undefined ? `${typeof value === 'number' ? value.toFixed(2) : value}` : '—'}
        {' '}
        <span style={{ fontSize: 12, fontWeight: 400, color: '#5f6b7a' }}>{unit}</span>
      </div>
      <div style={{ fontSize: 12, color: '#5f6b7a', marginTop: 2 }}>{label}</div>
    </div>
  );
}

ChannelGauge.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
